import { InitialNotesStateType } from "features/calendar-new/types";

export const getNotes = (state: InitialNotesStateType): any => {
  return state.entities.notes.entities;
};
